{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "id": "forge",
  "order": 6,
  "accent": "violet",
  "eyebrow": "COMPOSABLE BY DESIGN",
  "title": "Forge",
  "valueStatement": "Turn expertise into operational intelligence.",
  "outcome": "Transform expertise into capability.",
  "groups": {
    "BUILD": {
      "label": "Build",
      "description": "Create new capabilities.",
      "items": [
        "byom",
        "co-build",
        "ironfleet-network"
      ]
    },
    "CONNECT": {
      "label": "Connect",
      "description": "Connect existing systems.",
      "items": [
        "integrations",
        "workflow-extensions",
        "data-migration"
      ]
    }
  },
  "workflow": [
    "Identify expertise",
    "Design",
    "Govern",
    "Deploy",
    "Extend"
  ],
  "intelligenceInContext": {
    "name": "Your Intelligence",
    "headline": "Your modules and partner agents run with native governance.",
    "helpsWith": [
      "Run BYOM and co-built intelligence",
      "Host Ironfleet Network partner agents under the same governance"
    ],
    "drawsOn": [
      "Intelligence",
      "Platform Base"
    ],
    "humanAuthority": "Activation and governance approval stay with the customer.",
    "aiUsage": "Usage follows standard credit rules."
  },
  "evidenceProduced": [
    "Governed module outputs",
    "Partner-agent provenance"
  ],
  "regulatory": {
    "anchors": [],
    "included": [
      "Inherits host-module governance"
    ],
    "readinessServices": [
      "Regulatory review of BYOM/co-built modules"
    ]
  },
  "pricingId": "forge",
  "showExtensions": false
}